import React from 'react';
import PropTypes from 'prop-types';
import { Container, TextContainer, Title, SubTitle, Icon } from './delivery-failed-header.styles';

export const DeliveryFailedHeader = ({ onToggleOpenCard, isCardOpen, isMobile }) => {
  return (
    <Container onClick={onToggleOpenCard} isMobile={isMobile}>
      <TextContainer>
        <Title>{"We couldn't deliver your order"}</Title>
        <SubTitle>{"We'll let you know what happens next"}</SubTitle>
      </TextContainer>
      <Icon icon="chevron-up" width={20} height={20} isCardOpen={isCardOpen} />
    </Container>
  );
};

DeliveryFailedHeader.propTypes = {
  onToggleOpenCard: PropTypes.func.isRequired,
  isCardOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
};

DeliveryFailedHeader.defaultProps = {
  isMobile: false,
};

export default DeliveryFailedHeader;



// WEBPACK FOOTER //
// ./src/app/order-card/delivery-failed/header/delivery-failed-header.js